import { formatPublicMonthYear } from "@/lib/format-public-date";

export function slugifyHeading(text: string): string {
  return text
    .toLowerCase()
    .replace(/^\d+\.\s*/, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

export function parseLegalHeadings(html: string): { id: string; text: string }[] {
  const headings: { id: string; text: string }[] = [];
  const pattern = /<h2[^>]*>([\s\S]*?)<\/h2>/gi;
  let match = pattern.exec(html);
  while (match) {
    const text = match[1].replace(/<[^>]+>/g, "").trim();
    if (text) headings.push({ id: slugifyHeading(text), text });
    match = pattern.exec(html);
  }
  return headings;
}

export function addHeadingIds(html: string): string {
  return html.replace(/<h2([^>]*)>([\s\S]*?)<\/h2>/gi, (_full, attrs: string, inner: string) => {
    const text = inner.replace(/<[^>]+>/g, "").trim();
    const id = slugifyHeading(text);
    if (!id) return `<h2${attrs}>${inner}</h2>`;
    if (/\sid\s*=/.test(attrs)) return `<h2${attrs}>${inner}</h2>`;
    return `<h2 id="${id}"${attrs}>${inner}</h2>`;
  });
}

export function formatLegalLastUpdated(date: Date | string | null | undefined): string {
  return formatPublicMonthYear(date);
}
